import { render, staticRenderFns } from "./TableAllDataPaginated.vue?vue&type=template&id=1bf18962&"
import script from "./TableAllDataPaginated.vue?vue&type=script&lang=js&"
export * from "./TableAllDataPaginated.vue?vue&type=script&lang=js&"
import style0 from "./TableAllDataPaginated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports